module.exports = __webpack_public_path__ + "static/images/truck.23U4TWD.svg";